module.exports = __webpack_public_path__ + "static/media/call.0f3377a7.svg";